import { DateTime } from "luxon";
import { PackageResponse } from "../../subscriptions/modules/packages/models/PackageResponse";

export class PackageGroupResponse {
  /**
   * @param {Object} response
   * @param {String} response.id
   * @param {String} response.name
   * @param {PackageResponse[]} response.packages
   * @param {ฺBoolean} response.is_affect_app
   * @param {DateTime | null} response.deleted_at
   */
  constructor(response) {
    this.id = response.id;
    this.name = response.name;
    this.packages = response.packages;
    this.isAffectApp = response.is_affect_app;
    this.deletedAt = response.deleted_at;
  }
}


// WEBPACK FOOTER //
// ./src/features/group/models/PackageGroupResponse.js